<template>
    <iframe
        :src="conf.src"
        ref="analytics_element"
        name="sapoMailGTM"
        sandbox="allow-scripts allow-popups allow-same-origin"
        style="display: none;"
    >
    </iframe>
</template>


<script setup>
    import {ref, onMounted, onUnmounted} from 'vue';
    import GTMAnalyticsController        from '@/js/Webmail/Analytics/GTMAnalyticsController';
    import SAPOMailConfig                from '@/SAPOMailConfig';

    const conf              = SAPOMailConfig.server.analytics.GTM;
    const analytics_element = ref();

    onMounted(() => {
        GTMAnalyticsController.setEnabled(true);
        GTMAnalyticsController.setIframe(analytics_element.value);
        window.addEventListener('message', onMessage);
    });

    onUnmounted(() => {
        window.removeEventListener('message', onMessage);
    });

    const onMessage = (message) => {
        if (message.data !== 'READY') {
            return;
        }

        GTMAnalyticsController.setConnected(true);
        GTMAnalyticsController.publishQueue();
    }
</script>